export const templateKeys = {
  all: (tenantId: string) => ['templates', tenantId] as const,
  list: (tenantId: string) => ['templates', tenantId, 'list'] as const,
  design: (tenantId: string, templateId: string) =>
    ['templates', tenantId, 'design', templateId] as const,
};
